import { Box, Button, IconButton, MenuItem, Pagination, Stack, TableBody, TableCell, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import { useState } from 'react';
import route from '../../../utils/Routes';
import { customAlert, notify } from '../../../components/notify';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useEffect } from 'react';
import { getAmtcEmpListServ, updateEmpStatusServ } from '../../../services/amtc-service';
import StyledTableContainer from '../../../components/StyledTableContainer';
import { formatName, formatUserType } from '../../../utils/format';
import SearchTxtField from '../../../components/SearchTxtField';
import { Add, ArrowDropDown } from '@mui/icons-material';
import DDMenu from '../../../components/DDMenu';
import StyledSwitch from '../../../components/StyledSwitch';
import constants from '../../../utils/Constants';

const columns = [
    {
        id: 'empName',
        label: "Employee Name",
        align: 'left',
        minWidth: 150,
    },
    {
        id: 'empId',
        label: "Employee ID",
        align: 'left',
        minWidth: 150
    },
    {
        id: 'username',
        label: "Email ID",
        align: 'left',
        minWidth: 150,
    },
    {
        id: 'role',
        label: "Employee Role",
        align: 'left',
        minWidth: 150
    },
    {
        id: 'status',
        label: "Status",
        align: 'center',
        minWidth: 50
    }
];


const userTypeArr = [
    { value: "admin", label: "Admin" },
    { value: "sourcing", label: "Sourcing" },
    { value: "store", label: "Store" },
    { value: "accounts", label: "Accounts" }
];

function AmtcEmpListPage() {
    const navigate = useNavigate();
    const theme = useTheme();
    const { setLoadingScreen, setAsyncLoading, ctxtUser } = useAuthContext();
    const limit = 7;
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const status = searchParams.get("status") || "1";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
    const selUserType = searchParams.get("ut") || "";
    // const [selUserType, setSelUserType] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { isLoading, isError, error, data: empData, refetch } = useQuery([QueryKey.amtcEmpList, pgNo, isSrchBtnClick, selUserType, status],
        () => getAmtcEmpListServ({ limit, pageNumber: pgNo, searchWord, userType: selUserType, status }), {
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    const handleRowClick = (userId) => {
        navigate(`${route.aAmtcEmpInfo}/?userId=${userId}`);
    };
    function handleAddEmpClick() {
        navigate(route.aCreateAmtcEmp);
    };

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleRoleSelect = (role) => {
        // setSelUserType(role); // Update the selected status
        setSearchParams(prev => {
            prev.set("ut", role)
            return prev
        }, { replace: true })
        handleMenuClose();
    };

    async function updateEmpStatus(i) {
        setAsyncLoading(true);
        try {
            let status = i.status === 1 ? 0 : 1;
            const isComUser = constants.comUserArr.includes(i?.userType);
            const { message } = await updateEmpStatusServ({ userId: i.userId, status, isComUser });
            notify("success", message);
            refetch();
        } catch (err) {
            console.log(err);
            customAlert(err)
        }
        setAsyncLoading(false)
    }


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1, pl: 1, pr: 3 }} width={"100%"}>
                <Stack width={"30%"} >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, }}>{status === "1" ? "AMTC Employee List" : "Inactive AMTC Employee List"}</Typography>
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={400}>
                    <SearchTxtField width={"100%"} handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick}
                        placeholder="Search Emp By Name / Email / EmpId..." />
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} width={"30%"} gap={2}>
                    {status === "1" && <Button variant='outlined' onClick={handleAddEmpClick} startIcon={<Add />} sx={{
                        fontSize: 13,
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Create Employee</Button>}
                    {status === "1" ? <Button variant='contained' onClick={() => navigate(`${route.aAmtcEmpList}?status=0`)} sx={{
                        fontSize: 13, color: "white",
                        bgcolor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Inactive Employees</Button> : <Button variant='contained' onClick={() => navigate(route.aAmtcEmpList)} sx={{
                            fontSize: 13, color: "white",
                            bgcolor: theme?.palette?.custom?.btn, height: 30
                        }}>
                        Active Employees</Button>}
                </Stack>
            </Stack>
            {
                empData && <StyledTableContainer height={"81%"} isStickyHeader={true}>
                    <TableHead>
                        <TableRow >
                            {columns.map((column) => (
                                <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                    {column.label}
                                    {column.id === 'role' && (
                                        <div style={{ marginTop: -33, marginLeft: 100, height: 35 }} >
                                            <IconButton aria-haspopup="true" onClick={handleMenuOpen}>
                                                <ArrowDropDown />
                                            </IconButton>
                                        </div>
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(empData?.empArr || []).map((i) => {
                            return (
                                <React.Fragment key={i?.id}>
                                    <TableRow hover tabIndex={-1}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50 }} >
                                        {columns.map((column) => {
                                            const value = i[column.id];
                                            switch (column.id) {
                                                case "empName":
                                                    return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        <Button variant="text" sx={{ color: "black" }}
                                                            onClick={() => handleRowClick(i?.userId)}>
                                                            {formatName(i?.fName, i?.lName)}
                                                        </Button>
                                                    </TableCell>
                                                case "role":
                                                    return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {formatUserType(i?.userType)}
                                                    </TableCell>
                                                case "status":
                                                    return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        <StyledSwitch checked={i?.status === 1 ? true : false} onClick={() => { updateEmpStatus(i) }}
                                                            disabled={(ctxtUser?.userType === constants.admin && i?.userType !== constants.admin) ? false : true} />
                                                    </TableCell>
                                                default:
                                                    return (
                                                        <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                            {(value === null || value === "" || value === "null") ? "NA" : value}
                                                        </TableCell>
                                                    );
                                            }
                                        })}
                                    </TableRow>
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </StyledTableContainer>
            }
            <Stack sx={{ alignItems: "center", mt: 2 }}>
                <Pagination count={Math.ceil(empData?.totalEmpCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
                    variant="outlined" shape="rounded" />
            </Stack>
            <DDMenu open={open} handleClose={handleMenuClose} anchorEl={anchorEl} >
                <MenuItem onClick={() => handleRoleSelect("")}> All</MenuItem>
                {userTypeArr.map((i) => <MenuItem onClick={() => handleRoleSelect(i.value)} key={i.label}>
                    {i.label}
                </MenuItem>)}
            </DDMenu>
        </Box >
    )
}

export default AmtcEmpListPage

